import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiButton from "Components/MuiButton/MuiButton";
import FactorService from "Services/http/endpoints/factor/FactorService";
import { read } from "Helpers/LocalStorage";
import PreviewFactorDialog from "./components/FactorPrice/PreviewFactorDialog";
import showNotify from "Helpers/Notify";
import { useTranslation } from "react-i18next";
import { CAL_FACTOR_PRICE } from "Stores/actionTypes";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import StatusHandler from "Helpers/StatusHandler";

export default function FactorPreview({ disabled }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { factorResult, selectedProject, factorSetting } = useSelector(
    (state) => ({
      factorResult: state.factor.factorResult,
      factorSetting: state.factor.factorSetting,
      selectedProject: state.project.selectedProject,
    }),
  );
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const handleClose = () => {
    setOpen(false);
  };

  const onClick = async () => {
    setLoading(true);
    try {
      if (factorResult.ListUnitId.length > 0 || factorResult.CheckAll) {
        const data = {
          ...factorResult,
          ...factorSetting,
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id,
          OnlyPrice: false,
        };
        const response = await FactorService.saveFactorInfo(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          setOpen(true);
          setData(response.data.Value);
          dispatch({ type: CAL_FACTOR_PRICE, price: null });
        }
      } else if (
        factorResult.ListUnitId.length === 0 &&
        !factorResult.CheckAll
      ) {
        showNotify({
          text: t("Please_select_the_desired_unit"),
          customClass: "error",
        });
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (factorResult.ListUnitId.length > 0)
      dispatch({ type: CAL_FACTOR_PRICE, price: null });
  }, [factorResult]);

  return (
    <>
      <BackDropLoading loading={loading} />
      <MuiButton
        loading={loading}
        color="primary"
        disabled={disabled}
        title={t("Invoice_preview_v2")}
        onClick={onClick}
      />
      <PreviewFactorDialog open={open} handleClose={handleClose} data={data} />
    </>
  );
}
